module.exports = __webpack_public_path__ + "img/earth.d7cbfa88.png";